// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  padding: 0.8rem 0;
  background-color: var(--card-bg) !important;
  border-color: var(--border-color) !important;
  transition: all 0.3s ease;
}

.navbar .container-fluid {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.nav-link {
  font-weight: 500;
  font-size: 0.93rem;
  color: var(--text-color) !important;
  opacity: 0.8;
  transition: all 0.25s ease;
}

.nav-link:hover,
.nav-link.active {
  color: var(--primary-blue) !important;
  opacity: 1;
}

.theme-btn-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  color: var(--text-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.theme-btn-circle:hover {
  background-color: var(--border-color);
  transform: rotate(15deg) scale(1.1);
}

[data-theme="dark"] .navbar-toggler-icon {
  filter: invert(1) grayscale(1) brightness(2);
}

@media (max-width: 991px) {
  .navbar-collapse {
    display: none;
    background-color: var(--card-bg);
    padding: 1.2rem;
    z-index: 1000;
  }

  .navbar .container-fluid{
    max-width: auto;
  }

  .navbar-collapse.active {
    display: block;
    animation: slideDown 0.3s ease-out;
  }

  .navbar-nav {
    flex-direction: column;
    gap: 0.5rem;
  }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,2CAA2C;EAC3C,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":[".navbar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9999;\n  padding: 0.8rem 0;\n  background-color: var(--card-bg) !important;\n  border-color: var(--border-color) !important;\n  transition: all 0.3s ease;\n}\n\n.navbar .container-fluid {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n.nav-link {\n  font-weight: 500;\n  font-size: 0.93rem;\n  color: var(--text-color) !important;\n  opacity: 0.8;\n  transition: all 0.25s ease;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: var(--primary-blue) !important;\n  opacity: 1;\n}\n\n.theme-btn-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-color);\n  border: 1px solid var(--border-color);\n  color: var(--text-color);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.theme-btn-circle:hover {\n  background-color: var(--border-color);\n  transform: rotate(15deg) scale(1.1);\n}\n\n[data-theme=\"dark\"] .navbar-toggler-icon {\n  filter: invert(1) grayscale(1) brightness(2);\n}\n\n@media (max-width: 991px) {\n  .navbar-collapse {\n    display: none;\n    background-color: var(--card-bg);\n    padding: 1.2rem;\n    z-index: 1000;\n  }\n\n  .navbar .container-fluid{\n    max-width: auto;\n  }\n\n  .navbar-collapse.active {\n    display: block;\n    animation: slideDown 0.3s ease-out;\n  }\n\n  .navbar-nav {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
